import { useSelector } from 'react-redux'

import { selectIsInternalAdmin } from '../accessors/index'

export function useInternalAdmin() {
  return useSelector(selectIsInternalAdmin)
}
